import { Pipe, PipeTransform } from '@angular/core';
import { PlanningHasEntity } from '../classes/planning-has-entity.class';

@Pipe({
    name: 'entityType',
    pure: false,
    standalone: false,
})
export class EntityTypePipe implements PipeTransform {
    transform(plannings: PlanningHasEntity[], field, value): any {
        return plannings.filter(p => !!p.entitytype && p.entitytype[field] === value);
    }
}
